import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WarningCircle } from "@phosphor-icons/react";
import api, { apiErrorMessage } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const todayET = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });

export function ArchiveEmployeeDialog({ employee, unlockToken, onClose, onDone }) {
  const [date, setDate] = useState(todayET());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (employee) setDate(todayET()); }, [employee]);
  const go = async () => {
    setBusy(true);
    try {
      await api.post("/admin/salaries/archive", { employee, effective_date: date, unlock_token: unlockToken });
      toast.success(`${employee} archived — $0 pay from ${date}`);
      onDone();
    } catch (e) { toast.error(apiErrorMessage(e, "Archive failed")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!employee} onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="salary-archive-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-600"><WarningCircle size={18} weight="fill" /> Archive {employee}?</DialogTitle>
          <DialogDescription className="text-slate-700">
            This employee's pay must be set to <b>$0 starting on the archival effective date</b> so future Timesheet salary/spend calculations stop.
            Historical timesheets and salary expenses before that date will remain visible. Select the archival effective date and confirm.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="text-xs">Archival effective date</Label>
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1" data-testid="salary-archive-date" />
          <p className="text-[11px] text-slate-500 mt-1">Check, Cash, Tax WH and Addit. Pmt/Week become $0 from this date (any later-dated pay versions are replaced). Earlier versions and notes are kept.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="salary-archive-cancel">Cancel</Button>
          <Button onClick={go} disabled={busy || !date} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="salary-archive-confirm">{busy ? "Archiving…" : "Archive employee"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
